import api from "../../../../utils/api";

const UserApi = {
  // get all users
  async fetchUsers(params = {}) {
    const { queryString, queryParams, signal, ...restParams } = params; // Ignore unwanted params
    const response = await api.get(`/user?${queryString}&${queryParams}`, {
      params: restParams,
      signal,
    });
    return { data: response?.data };
  },

  // Fetch user by role
  async fetchUserByRole({ role, ...params }) {
    const response = await api.get(`/user/get-user-by-role/${role}`, {
      params,
      signal: params.signal,
    });
    return response.data;
  },

  // get user by id
  async fetchUser(params = {}) {
    const { userId, queryKey, signal, ...restParams } = params; // Ignore unwanted params
    const response = await api.get(`/user/${userId}`, {
      params: restParams,
      signal,
    });

    return response?.data?.data;
  },

  // add a user
  async addUser(userData) {
    const response = await api.post("/user", userData);

    return response?.data;
  },

  // update a user
  async updateUser(id, userData) {
    // remove reminder field from userData
    console.log("user data before",{...userData},userData?.reminders?.length);
    
    if (userData?.reminders?.length) {
      delete userData.reminders;
    }
    console.log("user data after",userData,userData?.reminders?.length);
    const response = await api.patch(`/user/changes/${id}`, userData);
    return response.data;
  },

  // disable user
  async disableUser(id, userData) {
     if (userData?.reminders?.length) {
      delete userData.reminders;
    }
    const response = await api.patch(`/user/disable-user/${id}`, userData);
    return response.data;
  },
};

export default UserApi;
